<template>
    <div class="w-full flex flex-col gap-2">
        <input v-if="channels_to_delete.length" type="hidden" id="channels_to_delete" name="channels_to_delete"
            :value="JSON.stringify(channels_to_delete)">
        <div :key="'forceUpdate_' + forceUpdate"></div>
        <div v-for="(item, index) in channels" :key="index"
            class="bg-gray-100 rounded-md border border-gray-300 flex justify-center items-center relative animate-in fade-in w-full">
            <div class="w-full relative">
                <div class="flex gap-2 items-center w-full p-2" >
                    <input type="hidden" :name="'CHANNELS['+index+'][id]'" :id="'CHANNELS['+index+'][id]'" :value="item.id ?? 'new'">
                    <input type="hidden" :name="'CHANNELS['+index+'][type]'" :id="'CHANNELS['+index+'][type]'" :value="$attrs.user ? 'USER' : $attrs.property ? 'PROPERTY' :  $attrs.room ? 'ROOM' : null">
                    <input v-if="$attrs.user" type="hidden" :name="'CHANNELS['+index+'][user_id]'" :id="'CHANNELS['+index+'][user_id]'" :value="JSON.parse($attrs.user).id">


                    <div class="flex items-center gap-2">
                        <input :id="'CHANNELS[' + index + '][active]'" type="checkbox" value="true" :name="'CHANNELS['+index+'][active]'"
                            v-model="item['active']"
                            class="w-4 h-4 text-primary bg-gray-100 border-gray-300 rounded focus:ring-primary focus:ring-2">
                        <label :for="'CHANNELS[' + index + '][active]'"
                            class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                            {{ $t('Active') }}
                        </label>
                    </div>

                    <search_select :id="'CHANNELS[' + index + '][channel]'" :options="JSON.parse($attrs.channel_options)" :show_ico="true"
                        class="p-0 m-0 border-none border-0 h-full max-w-xs" :closeOnSelect="true" :multiple="false" label="value"
                        value_by="name" :value="JSON.parse($attrs.channel_options).find((elem) => elem.name == item.channel)" 
                        >
                    </search_select>

                    <input v-if="$attrs.property || $attrs.room" class="border-gray-300 focus:border-primary-lighter focus:ring-primary-lighter rounded-md shadow-sm" type="text" 
                            :name="'CHANNELS[' + index + '][external_id]'" :id="'CHANNELS[' + index + '][external_id]'"  :ref="'CHANNELS[' + index + '][external_id]'"
                            v-model="item['external_id']" :placeholder="$t('external id')">

                    <div class="relative w-full">
                        <input class="border-gray-300 focus:border-primary-lighter focus:ring-primary-lighter rounded-md shadow-sm" type="text" 
                            :name="'CHANNELS[' + index + '][client_id]'" :id="'CHANNELS[' + index + '][client_id]'"  :ref="'CHANNELS[' + index + '][client_id]'"
                            v-model="item['client_id']" :placeholder="$t('client id')">
                        <div class="absolute right-1 top-0 h-full w-8 flex items-center justify-center">
                            <div @click="generateID(index)" class="w-8 h-8 rounded-full group cursor-pointer bg-white hover:bg-gray-200 flex items-center justify-center text-gray-400 hover:text-gray-600">
                                <svg class="w-5 h-5 group-hover:scale-90 transition" fill=currentColor xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"/></svg>
                            </div>
                        </div>
                    </div>

                    
                    <div class="relative w-full">
                        <input class="border-gray-300 focus:border-primary-lighter focus:ring-primary-lighter rounded-md shadow-sm" type="text" 
                            :name="'CHANNELS[' + index + '][client_secret]'" :id="'CHANNELS[' + index + '][client_secret]'" :ref="'CHANNELS[' + index + '][client_secret]'"
                            v-model="item['client_secret']" :placeholder="$t('client secret')">
                        <div class="absolute right-1 top-0 h-full w-8 flex items-center justify-center">
                            <div @click="generateSecret(index)" class="w-8 h-8 rounded-full group cursor-pointer bg-white hover:bg-gray-200 flex items-center justify-center text-gray-400 hover:text-gray-600">
                                <svg class="w-5 h-5 group-hover:scale-90 transition" fill=currentColor xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"/></svg>
                            </div>
                        </div>
                    </div>


                    <div class="relative w-full">
                        <input class="border-gray-300 focus:border-primary-lighter focus:ring-primary-lighter rounded-md shadow-sm" type="text" 
                            :name="'CHANNELS[' + index + '][host]'" :id="'CHANNELS[' + index + '][host]'"
                            :value="item['custom_url'] ?? ''" :placeholder="$t('custom url')">
                    </div>

                </div>


                <div @click="removeItem(index)"
                    class="w-5 h-5 absolute text-xs -right-2 -top-2 rounded-full bg-gray-100 text-gray-700 border border-gray-300 flex items-center justify-center hover:scale-90 transition cursor-pointer hover:bg-gray-300 z-5">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill=currentColor
                        viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                        <path
                            d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                    </svg>
                </div>
            </div>
        </div>
        <div @click="addItem" class="h-14 w-full">
            <label
                class="flex items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 js_file_input_preview h-full w-full relative group overflow-hidden">
                <div
                    class="flex items-center justify-center py-4 px-4  text-gray-500 js_skeleton z-[1] w-full h-full transition pointer-events-none">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mr-2 transition" fill=currentColor
                        viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                        <path
                            d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
                    </svg>
                    <p class="text-sm">
                        {{ $t("Click to Add") }}
                    </p>
                </div>
            </label>
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            channels: JSON.parse(this.$attrs.channels) ?? [],
            channels_to_delete: [],
            forceUpdate: 0,
        };
    },
    methods: {
        addItem(e) {
            if (this.channels.length < 9) {
                this.channels.push({});
            }
        },
        removeItem(index) {

            this.channels_to_delete.push(this.channels[index].id);

            var item = _.cloneDeep(this.channels);
            item.splice(index, 1);
            this.channels = [];

            var _this = this;
            setTimeout(function () {
                _this.channels = item;
            }, 1)
        },
        generateID(index) {
            if(confirm("Do you really want to generate a new client id?")){
                this.channels[index].client_id = "id_" + Math.random().toString(16).slice(4)+"_"+ Math.random().toString(16).slice(2);
                this.forceUpdate++;
            }
        },
        generateSecret(index) {
            if(confirm("Do you really want to generate a new client secret?")){
                this.channels[index].client_secret = "secret_" + Math.random().toString(16).slice(4)+"_"+ Math.random().toString(16).slice(2)+"_"+ Math.random().toString(16);
                this.forceUpdate++;
            }
        }
    }
};
</script>